import React, { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config';

const TaskDisplay = ({ selectedDate }) => {
    const [victories, setVictories] = useState({ mental: "", spiritual: "", physical: "", career: "" });
    const [tasks, setTasks] = useState({ main: "", min: "", secondary: "" });
    const [startX, setStartX] = useState(0); // Начальная позиция касания
    const [timeData, setTimeData] = useState({
        mental: null,
        spiritual: null,
        physical: null,
        career: null,
        main: null,
        min: null,
        secondary: null
    });
    const [activeKey, setActiveKey] = useState(''); // Ключ активного элемента
    const [selectedHour, setSelectedHour] = useState(''); // Выбранный час
    const [selectedMinute, setSelectedMinute] = useState(''); // Выбранная минута
    const [showModal, setShowModal] = useState(false); // Показать модальное окно
    const initData = window.Telegram.WebApp.initData;

    useEffect(() => {
        axios
            .post(`${config.API_BASE_URL}/calendar/get`, { selectedDate, initData })
            .then((response) => {
                if (response.data && response.data.data) {
                    const { victories, tasks, time } = response.data.data;
                    setVictories(victories || { mental: "", spiritual: "", physical: "", career: "" });
                    setTasks(tasks || { main: "", min: "", secondary: "" });
                    setTimeData(time || {
                        mental: null,
                        spiritual: null,
                        physical: null,
                        career: null,
                        main: null,
                        min: null,
                        secondary: null
                    });
                } else {
                    setVictories({ mental: "", spiritual: "", physical: "", career: "" });
                    setTasks({ main: "", min: "", secondary: "" });
                }
            })
            .catch((error) => {
                console.error("Ошибка загрузки данных календаря:", error);
                setVictories({ mental: "", spiritual: "", physical: "", career: "" });
                setTasks({ main: "", min: "", secondary: "" });
            });
    }, [selectedDate, initData]);

    // Устанавливаем активный ключ только при первом рендере
    useEffect(() => {
        const filteredVictories = Object.entries(victories).filter(([key, value]) => value && !timeData[key]);
        const filteredTasks = Object.entries(tasks).filter(([key, value]) => value && !timeData[key]);
        const combinedData = [...filteredVictories, ...filteredTasks];

        if (combinedData.length > 0) {
            setActiveKey(combinedData[0][0]); // Устанавливаем активный ключ на первый элемент
        }
    }, [victories, tasks, timeData]); // Зависимости для обновления активного ключа

    const handleTaskClick = (key) => {
        setActiveKey(key);
        setShowModal(true); // Открываем модальное окно при нажатии на задачу или победу

        // Если у задачи уже есть время, устанавливаем его в поля ввода
        if (timeData[key]) {
            const [hour, minute] = timeData[key].split(':');
            setSelectedHour(hour);
            setSelectedMinute(minute);
        } else {
            setSelectedHour('00');
            setSelectedMinute('00');
        }
    };

    const handleDotClick = (key) => {
        setActiveKey(key);
    };

    const handleSaveTime = () => {
        const selectedTime = `${selectedHour}:${selectedMinute}`; // Формируем строку времени

        // Обновляем объект времени
        const updatedTimeData = { ...timeData, [activeKey]: selectedTime }; // Сохраняем время для соответствующего ключа

        // Отправляем обновленные данные на сервер
        axios
            .post(`${config.API_BASE_URL}/calendar/save`, {
                selectedDate,
                initData,
                victories,
                tasks,
                time: updatedTimeData
            })
            .then(response => {
                console.log("Данные успешно сохранены:", response.data);
                setTimeData(updatedTimeData); // Обновляем состояние времени

                // Устанавливаем активный ключ на первый элемент из оставшихся
                const filteredVictories = Object.entries(victories).filter(([key, value]) => value && !updatedTimeData[key]);
                const filteredTasks = Object.entries(tasks).filter(([key, value]) => value && !updatedTimeData[key]);
                const combinedData = [...filteredVictories, ...filteredTasks];
                setActiveKey(combinedData.length > 0 ? combinedData[0][0] : ''); // Устанавливаем активный ключ

                setSelectedHour(''); // Сбрасываем выбранный час
                setSelectedMinute(''); // Сбрасываем выбранную минуту
                setShowModal(false); // Закрываем модальное окно
            })
            .catch(error => {
                console.error("Ошибка сохранения данных:", error);
                setActiveKey(''); // Сбрасываем активный ключ
                setSelectedHour(''); // Сбрасываем выбранный час
                setSelectedMinute(''); // Сбрасываем выбранную минуту
            });
    };

    const handleCancel = () => {
        setSelectedHour(''); // Сбрасываем выбранный час
        setSelectedMinute(''); // Сбрасываем выбранную минуту
        setShowModal(false); // Закрываем модальное окно
    };

    const handleTouchStart = (e) => {
        setStartX(e.touches[0].clientX); // Сохраняем начальную позицию касания
    };

    const handleTouchMove = (e) => {
        const deltaX = e.touches[0].clientX - startX; // Вычисляем смещение
        if (deltaX > 120) { // Свайп вправо
            const currentIndex = combinedData.findIndex(([key]) => key === activeKey);
            const nextIndex = (currentIndex === 0) ? combinedData.length - 1 : currentIndex - 1; // Переход к предыдущему элементу
            setActiveKey(combinedData[nextIndex][0]); // Устанавливаем новый активный ключ
            setStartX(e.touches[0].clientX); // Обновляем начальную позицию
        } else if (deltaX < -120) { // Свайп влево
            const currentIndex = combinedData.findIndex(([key]) => key === activeKey);
            const nextIndex = (currentIndex === combinedData.length - 1) ? 0 : currentIndex + 1; // Переход к следующему элементу
            setActiveKey(combinedData[nextIndex][0]); // Устанавливаем новый активный ключ
            setStartX(e.touches[0].clientX); // Обновляем начальную позицию
        }
    };

    // Объект для сопоставления ключей с заголовками
    const titleMap = {
        mental: 'Ментальная победа',
        spiritual: 'Духовная победа',
        physical: 'Физическая победа',
        career: 'Карьерная победа',
        main: 'Главная задача',
        min: 'Задача менее 2х минут',
        secondary: 'Второстепенная задача'
    };

    // Объединяем задачи и победы в один массив для отображения
    const combinedData = [...Object.entries(victories).filter(([key, value]) => value && !timeData[key]), ...Object.entries(tasks).filter(([key, value]) => value && !timeData[key])];

    const formatTimeValue = (value) => {
        // Проверяем, что значение является числом и находится в допустимом диапазоне
        let num = Number(value);
        if (isNaN(num)) num = 0;
        return num < 10 ? `0${num}` : `${num}`;
    };

    // Обработчики изменения часов и минут с проверкой диапазона
    const handleHourChange = (e) => {
        let value = Number(e.target.value);
        if (isNaN(value)) value = 0;
        if (value < 0) value = 0;
        if (value > 23) value = 23;
        setSelectedHour(formatTimeValue(value));
    };

    const handleMinuteChange = (e) => {
        let value = Number(e.target.value);
        if (isNaN(value)) value = 0;
        if (value < 0) value = 0;
        if (value > 59) value = 59;
        setSelectedMinute(formatTimeValue(value));
    };

    return (
        <div className="tasks-display">
            {combinedData.length > 0 ? (
                <div>
                    {/* Отображение задач и побед по одной */}
                    <div className={`tasks ${activeKey}`} onClick={() => handleTaskClick(activeKey)}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}>
                        <h3>{titleMap[activeKey]}</h3>
                        <p>{combinedData.find(([key]) => key === activeKey && !timeData[key])?.[1]}</p>
                    </div>
                    <div className="dots-container">
                        {combinedData.map(([key], index) => (
                            !timeData[key] && (
                                <div
                                    key={index}
                                    className={`dot ${key === activeKey ? 'active' : ''}`}
                                    onClick={() => handleDotClick(key)}
                                />
                            )
                        ))}
                    </div>
                </div>
            ) : null} {/* Убираем сообщение, если нет доступных задач или побед */}

            {/* Модальное окно для выбора времени - вынесено за пределы условного блока */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h4>{titleMap[activeKey]}</h4>
                        <div className="time-input-row">
                            <div className="time-input">
                                <button onClick={() => setSelectedHour(prev => formatTimeValue(Math.max(0, Math.min(23, Number(prev) - 1))))}>{"<"}</button>
                                <input
                                    type="number"
                                    value={selectedHour}
                                    onChange={handleHourChange}
                                    min="0"
                                    max="23"
                                />
                                <button onClick={() => setSelectedHour(prev => formatTimeValue(Math.max(0, Math.min(23, Number(prev) + 1))))}>{">"}</button>
                            </div>
                            <div className="divider">:</div>
                            <div className="time-input">
                                <button onClick={() => setSelectedMinute(prev => formatTimeValue(Math.max(0, Math.min(59, Number(prev) - 1))))}>{"<"}</button>
                                <input
                                    type="number"
                                    value={selectedMinute}
                                    onChange={handleMinuteChange}
                                    min="0"
                                    max="59"
                                />
                                <button onClick={() => setSelectedMinute(prev => formatTimeValue(Math.max(0, Math.min(59, Number(prev) + 1))))}>{">"}</button>
                            </div>
                        </div>
                        <div className="modal-buttons">
                            <button onClick={handleCancel}>Отмена</button>
                            <div className="divider">|</div>
                            <button onClick={handleSaveTime}>ОК</button>
                        </div>
                    </div>
                </div>
            )}

            <div>
                {Object.entries(timeData).map(([key, time]) => (
                    time && (
                        <div key={key} className="task-with-time" onClick={() => handleTaskClick(key)}>
                            <span className={`time-label`}>{time}</span> {/* Время слева от блока задачи */}
                            <div className={`task ${key}`}>
                                <h3>{titleMap[key]}</h3>
                                <p>{victories[key] || tasks[key] || ''}</p> {/* Отображаем текст задачи или победы */}
                            </div>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default TaskDisplay; 